import { createUseStyles } from 'react-jss'
import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { LinkOutlined } from '@ant-design/icons'
import { formatDateTime } from '../../lib/datetime'
import { getCommentablePath } from '../../lib/commentable-types'
import Comment from './Comment'

const useStyles = createUseStyles({
  commentContainer: {
    marginRight: '5rem',
  },
  Alert: {
    color: 'red',
  },
  Report: {
    color: 'brown',
  },
  OfficeCheck: {
    color: 'green',
  },
  PreAuthorization: {
    color: 'orange',
  },
})

export default function useColumns(handleUpdate, handleDelete, practiceId) {
  const classes = useStyles()
  return useMemo(() => {
    const columns = [
      {
        title: 'Datetime',
        dataIndex: 'createdAt',
        key: 'created_at',
        width: '20%',
        render: text => formatDateTime(text),
      },

      {
        title: 'Comment',
        width: '50%',
        key: 'message',
        render: comment => (
          <div className={classes.commentContainer}>
            <Comment
              comment={comment}
              onUpdate={handleUpdate}
              onDelete={handleDelete}
            />
          </div>
        ),
      },
      {
        title: 'Source',
        key: 'commentableType',
        width: '20%',
        render: (text, record) => {
          const path = getCommentablePath(
            record.commentableType,
            record,
            practiceId,
          )

          return (
            <Link to={path} className={classes[record.commentableType]}>
              {record.commentableType} <LinkOutlined />
            </Link>
          )
        },
      },
    ]
    return columns
  }, [handleUpdate, handleDelete, classes, practiceId])
}
